import React, { Component, useEffect, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Route, withRouter, Switch } from 'react-router-dom';

import $ from 'jquery';

import WP from 'WP';

import routes from 'routes';

import Header from 'partials/Header';
import StickyFooter from 'partials/StickyFooter';
import CheckoutGuard from 'partials/Checkout/CheckoutGuard';
//import Booking from 'partials/Booking';
import Advisor from 'partials/Calendly';
import ErrorBoundary from 'partials/ErrorBoundary';
import DevToolbar from 'partials/DevToolbar';
import Chat from 'partials/Chat';

import CookieBot from 'react-cookiebot';

import { maybePurgeStore, persistor } from 'store';

const Wrapper = styled.div`
    position: relative;
    min-height: 100vh;
    @media(max-width: 768px) {
        min-height: auto;
        height: auto;
    }
`

// Functional component for CookiebotWrapper
const CookiebotWrapper = () => {
    const [shouldLoad, setShouldLoad] = useState(false);

    useEffect(() => {
        const existingScript = document.querySelector('script[src*="uc.js"]');
        if (!existingScript) {
            setShouldLoad(true);
        } else {
            console.warn("Cookiebot script already present. Skipping <CookieBot /> render.");
        }
    }, []);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const existingScript = document.querySelector('script[src*="uc.js"]');
            if (existingScript) {
                setShouldLoad(false);
                console.warn("Cookiebot script already present. Skipping <CookieBot /> render(detected via MutationObserver).");
                observer.disconnect(); 
            }
        });

        observer.observe(document.head || document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    return shouldLoad ? (
        <CookieBot domainGroupId={process.env.REACT_APP_COOKIE_BOT_KEY} />
    ) : null;
};

class App extends Component {
    componentDidMount() {
        const self = this;

        // fix for internal links created in WP editor
        document.addEventListener('click', function (e) {
            if (e.defaultPrevented) {
                console.log('[App] click intercepted but defaultPrevented — skipping navigation');
                return;
            }
            // Walk up from the actual click target to find the closest <a>
            const anchor = e.target.closest('a');
            if (anchor) {
                const href = anchor.getAttribute('href');
                if (href && href.indexOf(WP.base_url) !== -1) {
                    const fixedHref = (href.replace(WP.base_url, '') || '/').replace(/^([^/])/, '/$1');
                    // Skip navigation if it targets the current pathname (booking-trigger links
                    // use the page URL as a no-JS fallback; React handles them via onClick)
                    if (fixedHref === window.location.pathname) {
                        console.log('[App] same-page href detected — skipping navigation to:', fixedHref);
                        return;
                    }
                    console.log('[App] navigating to:', fixedHref);
                    e.preventDefault();
                    self.props.history.push(fixedHref);
                }
            }
        }, false);

        $('#root').removeClass('loading');

        // Action when route changes
        this.props.history.listen((location, action) => {
            maybePurgeStore(persistor);
        });
    }

    render() {
        const { location } = this.props;
        const customViewLayout = ['blogg'];
        const customView = customViewLayout.findIndex(element => !location.pathname.includes(element));

        return (
            <Wrapper>

                <CookiebotWrapper />

                { !customView &&
                    <ErrorBoundary for="Header">
                        <Header />
                    </ErrorBoundary>
                }

                <Switch location={location}>
                    {routes.map((route, i) => {
                        const { path, component, exact } = route;

                        if (Array.isArray(path)) {
                            return path.map((path, i) => <Route key={i} exact={exact} path={path} component={component} />)
                        }

                        return <Route key={i} exact={exact} path={path} component={component} />
                    })}
                </Switch>

                <CheckoutGuard />
                <Advisor />
                <StickyFooter />
                <Chat appId={process.env.REACT_APP_INTERCON_APP_ID} />

                {process.env.NODE_ENV === 'development' &&
                    <DevToolbar />
                }
            </Wrapper>
        );
    }
}

export default withRouter(connect(null, {})(App));


// WEBPACK FOOTER //
// ./src/App.js